import { useVolunteerStore } from '@/stores/volunteer'
import { useOtherChildEditionIdsStore } from '@/stores/otherChildEditionIds'
import { useChildEditionPreviousEditionStore } from '@/stores/childEditionPreviousEdition'
import { useVolunteerCooperationStore } from '@/stores/volunteerCooperation'
import { useChildEditionFlowActionsStore } from '@/stores/childEditionFlowActions'
import { usePaymentFlowActionsStore } from '@/stores/paymentFlowActions'

/**
 * Composable for clearing Pinia stores on logout
 * Add any store that should be cleared when user logs out
 */
export const useClearStoresOnLogout = () => {
  const clearOnLogout = () => {
    const volunteerStore = useVolunteerStore()
    const otherChildEditionIdsStore = useOtherChildEditionIdsStore()
    const childEditionPreviousEditionStore = useChildEditionPreviousEditionStore()
    const volunteerCooperationStore = useVolunteerCooperationStore()
    const childEditionFlowActionsStore = useChildEditionFlowActionsStore()
    const paymentFlowActionsStore = usePaymentFlowActionsStore()

    volunteerStore.clear()
    otherChildEditionIdsStore.clear()
    childEditionPreviousEditionStore.clear()
    volunteerCooperationStore.clear()
    childEditionFlowActionsStore.clearDataAndCache()
    paymentFlowActionsStore.clearDataAndCache()
  }

  return {
    clearOnLogout
  }
}
